import { ValidationErrors, ValidatorFn, AbstractControl, FormControl, UntypedFormGroup } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';

export class CustomValidator {

    static phoneNumberValidator(form: UntypedFormGroup) {
        if (form?.controls?.phoneNumber?.value) {
            const phoneNumberUtil = PhoneNumberUtil.getInstance();
            const phoneNumberInput: string = form.controls.phoneNumber.value;
            if ((phoneNumberInput || '').trim().length !== 0) {
                try {
                    // console.log('+' + form.controls.selectCode.value + phoneNumberInput);
                    const phoneNumber = phoneNumberUtil.parse('+' + form.controls.selectCode.value + phoneNumberInput);
                    if (!phoneNumberUtil.isValidNumber(phoneNumber)) {
                        form.controls.phoneNumber.setErrors({ 'phoneNumberInvalid': true });
                        return;
                    }
                } catch (error) {
                    console.log(error);
                    form.controls.phoneNumber.setErrors({ 'phoneNumberInvalid': true });
                    return;
                }
            }
        } else {
            form.controls.phoneNumber.setErrors({ 'phoneNumberInvalid': true });
            return;
        }
        form.controls.phoneNumber.setErrors(null);
    }
}